tinymce.PluginManager.add('rightmargin', function (editor) {
    const width = '10px'    
    const container = document.createElement('div');
    editor.on('init', _e => {        
        const root = editor.contentDocument.activeElement;        
        root.style.marginRight = width;                
        editor.contentAreaContainer.appendChild(container);
    });
})